import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';

// Detection order — a user's saved profile choice wins first, then the browser
// language, and finally we fall back to English. Currently the language switcher
// is disabled in the UI (i18n coverage was incomplete and confusing to users);
// the plumbing stays so we can re-enable it once translations are properly editable.
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr },
            es: { translation: es },
        },
        lng: 'en',           // FORCED English until the translation editor ships
        fallbackLng: 'en',
        supportedLngs: ['en', 'fr', 'es'],
        interpolation: { escapeValue: false }, // React already escapes
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'm4l_lang',
        },
    });

export default i18n;
